import { view, cssGenerator } from '@yola/ws-sdk';
import selectors from '../../../common/constants/selectors';
import getCompositeItemPosition from '../../../common/helpers/get-composite-item-position';
import { DESKTOP_BREAKPOINT, EDITOR_BREAKPOINTS } from '../../../common/constants/breakpoints';
import calculateDuplicatedItemPosition from './calculate-duplicated-item-position';
import calculateNewItemPosition from './calculate-new-item-position';
import calculateCreationSequence from './calculate-creation-sequence';
import constants from '../constants/common';

const { POSITION: POSITION_CLASS } = cssGenerator.constants.classNames;
const { DATA_CREATION_SEQUENCE_ATTRIBUTE } = constants;

const isPinnedToBottomRightCorner = ({ x, y }) => x === 100 && y === 100;

const setDuplicatedCompositeItemPositions = (element, compositionGroup) => {
  const newClass = EDITOR_BREAKPOINTS.reduce(
    (currentClass, breakpoint) => {
      const explicitValue = view.accessors.getResponsiveClassValue({
        element,
        className: POSITION_CLASS,
        breakpoint,
      })?.value;

      if (breakpoint !== DESKTOP_BREAKPOINT && !explicitValue) {
        return currentClass;
      }

      const position = getCompositeItemPosition({ element, breakpoint });
      const value = isPinnedToBottomRightCorner(position)
        ? calculateNewItemPosition(compositionGroup, breakpoint)
        : calculateDuplicatedItemPosition(element, breakpoint);

      return view.helpers.getPatchedResponsiveClass({
        currentClass,
        className: POSITION_CLASS,
        value,
        breakpoint,
      });
    },
    element.getAttribute('class') || ''
  );

  element.setAttribute('class', newClass);
};

function duplicateCompositeItem({ elementId }) {
  const compositeItemLiveNode = view.accessors.getLiveElement(elementId);
  const compositeGroupLiveNode = compositeItemLiveNode.closest(selectors.COMPOSITE_GROUP);

  const compositeGroupElementId = view.accessors.getLiveElementId(compositeGroupLiveNode);
  const compositionGroup = view.accessors.getStaticElement(compositeGroupElementId);
  const compositeItem = view.accessors.getStaticElement(elementId);

  const clonedCompositeItem = compositeItem.cloneNode(true);
  const dataCreationSequence = calculateCreationSequence(compositionGroup);

  setDuplicatedCompositeItemPositions(clonedCompositeItem, compositionGroup);
  clonedCompositeItem.setAttribute(DATA_CREATION_SEQUENCE_ATTRIBUTE, dataCreationSequence);
  compositionGroup.appendChild(clonedCompositeItem);

  view.operations.replaceElement(compositionGroup, compositeGroupElementId);
}

export default duplicateCompositeItem;
